import {
	PARAGRAPH_KEY,
	HEADING_KEY,
	LIST_ITEM_KEY
} from '@techchange/pm-specs';

import { updateNodeAttrsBulk } from '../core/commands';

/**
 * Updates the current selection to use the specified alignment.
 *
 * @param {Object} attrs    The attributes to apply to the selected text nodes.
 *
 * @returns {Function} Parametrized command to update the selection.
 *
 */
export const toggleAlignment = (attrs) => {

	return (state, dispatch) => {

		const { selection: { from, to } } = state;

		const paragraphNodeType = state.schema.nodes[PARAGRAPH_KEY];
		const headingNodeType = state.schema.nodes[HEADING_KEY];
		const listItemNodeType = state.schema.nodes[LIST_ITEM_KEY];

		const textNodes = [];

		state.doc.nodesBetween(from, to, (node, pos) => {

			if (node.type === paragraphNodeType ||
				node.type === headingNodeType ||
				node.type === listItemNodeType) {

				textNodes.push({
					...node,
					pos,
				});

			}

			return true;

		});

		updateNodeAttrsBulk(textNodes, attrs)(state, dispatch);

		return true;

	};

};
